import React from 'react';
import Link from 'next/link';
import { Shield } from 'lucide-react';

interface LoginFooterProps {
  year: string;
}

export default function LoginFooter({ year }: LoginFooterProps) {
  return (
    <footer className="w-full border-t border-border bg-card px-6 py-4">
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Shield size={12} className="text-muted-foreground" />
          <span className="text-[11px] text-muted-foreground">
            Authentication enforced by AAC Control Policy · TLS 1.3 encrypted
          </span>
        </div>
        <div className="flex items-center gap-4">
          <Link href="/terms" className="text-[11px] text-muted-foreground hover:text-foreground transition-colors">Terms of Service</Link>
          <Link href="/privacy" className="text-[11px] text-muted-foreground hover:text-foreground transition-colors">Privacy Policy</Link>
          <Link href="/support" className="text-[11px] text-muted-foreground hover:text-foreground transition-colors">Support</Link>
          <span className="text-[11px] text-muted-foreground">© {year} API App Cloud</span>
        </div>
      </div>
    </footer>
  );
}